import { render, staticRenderFns } from "./DocumentActionTable.vue?vue&type=template&id=05faced3&scoped=true"
import script from "./DocumentActionTable.vue?vue&type=script&lang=js"
export * from "./DocumentActionTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentActionTable.vue?vue&type=style&index=0&id=05faced3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05faced3",
  null
  
)

export default component.exports